export const MIN_ASKING_PRICE = 5000;